import React, { useState } from 'react';
import { AuthInformation } from './AuthContext';
import {BusyContainer} from "../components/BusyContainer";

interface UserInfo {
    Name: string;
    SessionId: string;
}

interface LoginPaneProps {
    using: (loginInformation: AuthInformation) => void;
}

export const LoginPane: React.FunctionComponent<LoginPaneProps> = ({using}) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const doLogin = ( e: React.SyntheticEvent ): boolean => {
        e.preventDefault();
        setLoading(true);
        void fetch('index.php?uri=api/login/login', {
            method: 'post',
            body: new URLSearchParams({
                user: username,
                password
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then( resp => {
            if (!resp.ok) {
                setError('Invalid username or password');
                return;
            }
            return resp.json();
        }).then( (authDetails: UserInfo) => {
            using({
                isLoggedIn: true,
                name: authDetails.Name,
                sessionId: authDetails.SessionId
            });
        }).finally(() => { setLoading(false); });
        return false;
    };

    return (
        <form onSubmit={doLogin} className="form centered">
            <div className="title">Login</div>
            <div className="row">
                <div className="label">
                    <label>Username:</label>
                </div>
                <div className="field">
                    <input type="text" id="user" tabIndex={0} value={username} autoFocus={true} onChange={e => { setUsername(e.currentTarget.value); } } />
                </div>
            </div>
            <div className="row">
            <div className="label">
                    <label>Password:</label>
                </div>
                <div className="field">
                    <input type="password" id="password" value={password} tabIndex={1} onChange={e => { setPassword(e.currentTarget.value); } } />
                </div>
            </div>
            { error && <div className="error"><span>{ error }</span></div> }
            <div>
                <button type="submit" tabIndex={2} onClick={doLogin}>Login</button>
            </div>
            { loading && <BusyContainer text="loading" /> }
        </form>
    );
};